import { useUser } from "../contexts/UserContext";
import { USER_TYPES } from "../types/userType";

const useIsFreesbe = () => {
  const { userType } = useUser();

  if (!userType) return false;
  if (Array.isArray(userType)) {
    return userType.includes(USER_TYPES.FREESBE);
  }
  return userType === USER_TYPES.FREESBE;
};

export default useIsFreesbe;
